<template>
  <div class="footer">
    <div class="button-container">
      <b-button class="icon-box" :to="{name: routeScanName}">
        <img src="@/assets/images/icon/qr-code-scan.png" alt="">
      </b-button>
      <b-button class="icon-box2" :to="{name: routeFacialName}">
        <img src="@/assets/images/icon/facial-recog.png" alt="" width="34px">
      </b-button>
    </div>
  </div>
</template>

<script>
import { CHECK_IN_PAGE_SCAN, CHECK_IN_PAGE_FACIAL } from '@/modules/check-in/routes'

export default {
  name: 'index-footer',
  data: () => ({
    routeScanName: CHECK_IN_PAGE_SCAN,
    routeFacialName: CHECK_IN_PAGE_FACIAL
  })
}
</script>

<style scoped>
.footer {
z-index: 2;
  background-color: #292f41;
  position: fixed;
}

.icon-box {
  color: #ffffff;
  font-size: 25px;
  background-color: #564AB1;
  width: 64px;
  height: 64px;
  border-radius: 100%;
  position: absolute;
  display: grid;
  place-items: center;
  border: 0;
  top: -50%;
  left: 46%;
  transform: translate(-50%);
}
.icon-box2 {
  color: #ffffff;
  font-size: 25px;
  background-color: #564AB1;
  width: 64px;
  height: 64px;
  border-radius: 100%;
  position: absolute;
  display: grid;
  place-items: center;
  border: 0;
  top: -50%;
  left: 50%;
  transform: translate(-50%);
}
.icon-box2 img {
  filter: brightness(0) invert(1);
}
@media (max-width: 767px) {
  .button-container {
    padding: 8px;
  }

  .icon-box {
    width: 48px;
    height: 48px;
    font-size: 20px;
  }

   .icon-box2 {
    width: 48px;
    height: 48px;
    font-size: 20px;
    margin-left: 40px;
  }
 .icon-box2 img {
    width: 24px;
  }
  .icon-box img {
    width: 24px;
  }
}
</style>
